import React from 'react';
import DesktopPasswordCaption from './Desktop';
import MobilePasswordCaption from './Mobile';

const PasswordCaption = ({ mobile }) => {
  if (mobile) {
    return <MobilePasswordCaption />;
  }
  return <DesktopPasswordCaption />;
};

// TODO: move to Flow types
// PasswordCaption.propTypes = {
//   mobile: PropTypes.bool
// };

export default PasswordCaption;
